import Plugin from 'src/plugin-system/plugin.class';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default class VomSchockenZumBackenPlugin extends Plugin {

    init() {

        gsap.registerPlugin(ScrollTrigger);

        gsap.set(".vom-schocken-zum-backen-widget__teig-image-wrapper", {
            zIndex: (i, target, targets) => targets.length + i
        });
        gsap.set(".vom-schocken-zum-backen-widget__teig-image-wrapper > img", {
            zIndex: (i, target, targets) => targets.length + i
        });
        gsap.set(".vom-schocken-zum-backen-widget__text", {
            zIndex: (i, target, targets) => targets.length + i
        });

        var teigImgs = gsap.utils.toArray(".vom-schocken-zum-backen-widget__teig-image");

        var imageAnimation = gsap.timeline()
            .fromTo(teigImgs[0], {
                opacity: 1
            }, {
                opacity: 1,
                duration: 0.33
            }, 0)
            .to(teigImgs[1], {
                scale: 1,
                duration: 0.33
            }, 0.33)
            .fromTo(teigImgs[1], {
                opacity: 0
            }, {
                opacity: 1,
                duration: 0.33
            }, 0.33)
            .fromTo(teigImgs[2], {
                opacity: 0
            }, {
                opacity: 1,
                duration: 0.33
            }, 0.66);
            // .fromTo(teigImgs[3], {
            //     opacity: 0
            // }, {
            //     opacity: 1,
            //     duration: 0.33
            // }, 0.75);


        var texts = gsap.utils.toArray(".vom-schocken-zum-backen-widget__text");

        // var textAnimation = gsap.timeline()
        //     .fromTo(texts[0], {
        //         opacity: 1
        //     }, {
        //         opacity: 1,
        //         duration: 0.25
        //     }, 0)

        //     .fromTo(texts[1], {
        //         opacity: 0
        //     }, {
        //         opacity: 1,
        //         duration: 0.25
        //     }, 0.25)
        //     .to(texts[0], {
        //         opacity: 0,
        //         duration: 0.25
        //     }, 0.25)

        //     .fromTo(texts[2], {
        //         opacity: 0
        //     }, {
        //         opacity: 1,
        //         duration: 0.25
        //     }, 0.5)
        //     .to(texts[1], {
        //         opacity: 0,
        //         duration: 0.25
        //     }, 0.5)

        //     .fromTo(texts[3], {
        //         opacity: 0
        //     }, {
        //         opacity: 1,
        //         duration: 0.25
        //     }, 0.75)
        //     .to(texts[2], {
        //         opacity: 0,
        //         duration: 0.25
        //     }, 0.75);

        // let playhead = { frame: 0 },
        //     animation = lottie.loadAnimation({
        //         container: document.querySelector("#vom-schocken-zum-backen-lottie"),
        //         renderer: "svg",
        //         loop: false,
        //         autoplay: false,
        //         animationData: animationData,
        //     });

        // var lottieAnimation = gsap.timeline()
        //     .add("lottie")
        //     .to(playhead, {
        //         frame: animation.totalFrames - 1,
        //         duration: 1,
        //         ease: "none",
        //         onUpdate: () => {
        //             animation.goToAndStop(playhead.frame, true);
        //         }
        //     });

        ScrollTrigger.create({
            trigger: this.el,
            start: 'top',
            end: '100% top',
            pin: true,
            animation: imageAnimation,
            markers: false,
            scrub: 1,
            duration: 1,
            toggleActions: "restart pause reverse pause"
        });

        ScrollTrigger.create({
            trigger: this.el,
            start: 'top',
            end: '100% top',
            pin: false,
            //animation: textAnimation,
            markers: false,
            scrub: 1,
            duration: 1,
            onRefresh: (self) => {
                texts[0].style.opacity = "1";
                texts[0].style.pointerEvents = "auto";

                texts[1].style.opacity = "0";
                texts[1].style.pointerEvents = "none";

                texts[2].style.opacity = "0";
                texts[2].style.pointerEvents = "none";

                gsap.to('.vom-schocken-zum-backen-widget__vector', {
                    color: '#00B2E3'
                });

                if (self.progress <= 0.33) {
                    texts[0].style.opacity = "1";
                    texts[0].style.pointerEvents = "auto";

                    texts[1].style.opacity = "0";
                    texts[1].style.pointerEvents = "none";

                    texts[2].style.opacity = "0";
                    texts[2].style.pointerEvents = "none";

                    gsap.to('.vom-schocken-zum-backen-widget__vector', {
                        color: '#00B2E3'
                    });
                }
                if (self.progress > 0.33 && self.progress <= 0.66) {
                    texts[0].style.opacity = "0";
                    texts[0].style.pointerEvents = "none";

                    texts[1].style.opacity = "1";
                    texts[1].style.pointerEvents = "auto";

                    texts[2].style.opacity = "0";
                    texts[2].style.pointerEvents = "none";

                    gsap.to('.vom-schocken-zum-backen-widget__vector', {
                        color: '#00B2E3'
                    });
                }
                if (self.progress > 0.66 && self.progress <= 1) {
                    texts[0].style.opacity = "0";
                    texts[0].style.pointerEvents = "none";

                    texts[1].style.opacity = "0";
                    texts[1].style.pointerEvents = "none";

                    texts[2].style.opacity = "1";
                    texts[2].style.pointerEvents = "auto";

                    gsap.to('.vom-schocken-zum-backen-widget__vector', {
                        color: '#E3000F'
                    });
                }
            },
            onUpdate: (self) => {
                if (self.progress <= 0.33) {
                    texts[0].style.opacity = "1";
                    texts[0].style.pointerEvents = "auto";

                    texts[1].style.opacity = "0";
                    texts[1].style.pointerEvents = "none";

                    texts[2].style.opacity = "0";
                    texts[2].style.pointerEvents = "none";

                    gsap.to('.vom-schocken-zum-backen-widget__vector', {
                        color: '#00B2E3'
                    });
                }
                if (self.progress > 0.33 && self.progress <= 0.66) {
                    texts[0].style.opacity = "0";
                    texts[0].style.pointerEvents = "none";

                    texts[1].style.opacity = "1";
                    texts[1].style.pointerEvents = "auto";

                    texts[2].style.opacity = "0";
                    texts[2].style.pointerEvents = "none";

                    gsap.to('.vom-schocken-zum-backen-widget__vector', {
                        color: '#00B2E3'
                    });

                }
                if (self.progress > 0.66 && self.progress <= 1) {
                    texts[0].style.opacity = "0";
                    texts[0].style.pointerEvents = "none";

                    texts[1].style.opacity = "0";
                    texts[1].style.pointerEvents = "none";

                    texts[2].style.opacity = "1";
                    texts[2].style.pointerEvents = "auto";

                    gsap.to('.vom-schocken-zum-backen-widget__vector', {
                        color: '#E3000F'
                    });
                }
            },
            toggleActions: "restart pause reverse pause"
        });

    }

}
